import { AppCustomLine as CustomLine, AppProductLine as ProductLine } from 'graphql/models/extended';
import { LineSubtypePropVal } from 'models/position.model';

export function isExternalArticleLine(value: unknown): value is CustomLine {
  return Boolean(
    typeof value === 'object'
      && (
        ((value as CustomLine).articleCustom || (value as CustomLine).article)
        || (value as CustomLine).lineSubtype === LineSubtypePropVal.FREE_ARTICLE
        || ((value as CustomLine).article === null && (value as CustomLine).articleCustom === null && !(value as ProductLine).product)
      )
      && !(value as CustomLine).parentLine
  );
}
